import React from "react";
import { ProductCard } from "@/components/product/ProductCard";
import { PackageOpen } from "lucide-react";

function Skeleton() {
  return (
    <div className="flex flex-col animate-pulse">
      <div className="aspect-[4/5] w-full bg-cream" />
      <div className="pt-4 space-y-2">
        <div className="h-2 w-16 bg-cream" />
        <div className="h-4 w-3/4 bg-cream" />
        <div className="h-3 w-1/3 bg-cream" />
      </div>
    </div>
  );
}

export function ProductGrid({ products = [], loading = false, onQuickView, columns = 4, skeletonCount = 8, emptyMessage = "No pieces found." }) {
  const cols =
    columns === 3
      ? "grid-cols-2 md:grid-cols-3"
      : columns === 2
      ? "grid-cols-1 sm:grid-cols-2"
      : "grid-cols-2 lg:grid-cols-4";

  if (loading) {
    return (
      <div className={`grid ${cols} gap-x-5 gap-y-10 sm:gap-x-8`}>
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <Skeleton key={i} />
        ))}
      </div>
    );
  }

  if (!products.length) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="empty-products">
        <PackageOpen className="h-10 w-10 text-gold mb-4" strokeWidth={1.2} />
        <p className="font-serif text-2xl text-ink">{emptyMessage}</p>
        <p className="mt-2 text-sm text-muted-foreground">Try adjusting your filters or search.</p>
      </div>
    );
  }

  return (
    <div className={`grid ${cols} gap-x-5 gap-y-10 sm:gap-x-8`} data-testid="product-grid">
      {products.map((p) => (
        <ProductCard key={p.handle} product={p} onQuickView={onQuickView} />
      ))}
    </div>
  );
}
